import React from "react";
import {useSelector, useDispatch} from "react-redux";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

//redux:
import {editComponent, selectAllComponents, selectComponentsStatus} from "../../../../redux/Settings/homePageSlice";

//components:
import CarouselsTable from "./Table";
import {CircularProgress} from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";

const CarouselsCard = () => {
    const {t} = useTranslation();

    const dispatch = useDispatch();
    const carousels = useSelector(selectAllComponents);
    const carouselsStatus = useSelector(selectComponentsStatus);

    const onCarouselEdit = (value, key, id) => {
        dispatch(editComponent({value, key, id}));
    };

    const getContent = () => {
        if (carouselsStatus.type === "succeeded") {
            if (carousels?.length) {
                return <CarouselsTable t={t} carousels={carousels} editCarousel={onCarouselEdit} />;
            } else
                return (
                    <div className="alert alert-light text-dark w-fit-content">
                        {t("ADMINPANEL.HOMEPAGE.CAROUSELS.EMPTY_MESSAGE")}
                        <Link to={"/adminpanel/tracks"}>{t("ADMINPANEL.TRACKS_MANAGEMENT")}</Link>
                    </div>
                );
        } else if (carouselsStatus.type === "loading" || carouselsStatus.type === "idle") {
            if (carousels)
                return (
                    <div className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100">
                        <CircularProgress />
                    </div>
                );
        }
    };

    return (
        <div className="homepage_carousels card card-custom gutter-b shadow">
            <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-gray">
                <div className="card-title">Carousels</div>
            </div>
            <div className="card-body position-relative min-h-180px">
                {carouselsStatus.text ? (
                    <div className={`alert alert-warning font-weight-bold w-fit-content d-flex align-items-center`}>
                        <WarningRoundedIcon color="inherit" className="mr-5" />
                        {carouselsStatus.text}
                    </div>
                ) : null}
                {getContent()}
            </div>
        </div>
    );
};

export default CarouselsCard;
